import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

// Import Local Styles
import reserving from '~/common/images/reserving.png';
import styles from './lockingNumberBlocker.css';

@inject('lockNumberStore')
@observer
class LockingNumberBlocker extends Component {
    render() {
        const { lockingNumber } = this.props.lockNumberStore;
        // if number is being locked
        if (lockingNumber) {
            return (
                <div className={styles.lockingNumberBlocker} data-test="locking-number-blocker">
                    <img
                        alt="Reserving your number"
                        src={reserving}
                        title="Reserving your number"
                    />
                    <h1>Reserving your number...</h1>
                    <div className={styles.lockingNumberBg}></div>
                </div>
            );
        }
        return null;
    }
}

export default LockingNumberBlocker;
